import { gql } from "@apollo/client";

export const CAPTCHA_CODE = gql`
mutation CaptchaCode($userName:String!){
    captchaCode(userName:$userName){
        a,
        status
    }
}
`;